import React, { createRef } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { selectExtraHeaderHeight } from '../../state/selectors'
import { mediaQueries, palette, sizes } from '../../styles/variables'
import { isIOS } from '../../utils/functions'
import { AppBanner, HIDE_ON_PAGES } from '../panels/AppBanner/appBanner'

const ContentWrapper = styled.div((props) => ({
  padding: props.noPadding
    ? 0
    : `${
        props.safeAreaBottom
          ? `${sizes.contentSeparation} ${sizes.contentSeparation} ${props.safeAreaBottom}`
          : sizes.contentSeparation
      }`,
  '@media only screen and (min-width: 1400px)': {
    padding: props.noPadding
      ? 0
      : `${sizes.contentSeparation} calc(2% + ${sizes.contentSeparation}) ${
          props.safeAreaBottom || sizes.contentSeparation
        }`,
  },
  '@media only screen and (min-width: 2000px)': {
    padding: props.noPadding
      ? 0
      : `${props.safeAreaBottom || sizes.contentSeparation} calc(8% + ${
          sizes.contentSeparation
        })`,
  },
  [mediaQueries.mobile]: {
    padding: '0px',
  },
}))

export const Container = styled.div({
  height: 'auto',
  '@supports (-ms-ime-align: auto)': { paddingBottom: '30px' },
  [mediaQueries.mobile]: {
    padding: '15px',
    position: 'relative',
  },
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
})

const Frame = styled.div((props) => ({
  width: '100%',
  height: `calc(100vh - ${props.topSpacing}px)`,
  overflowY: 'auto !important',
  backgroundColor: props.bgGrey ? palette.lightGray50 : palette.white,
  [mediaQueries.mobile]: {
    height: `calc(100vh - ${props.topSpacing}px)`,
    paddingBottom: '80px',
  },
  overflowX: props.overflowX || 'auto',
}))

export const ContentFrame = ({ forwardRef, ...props }) => {
  const extraHeaderHeight = useSelector(selectExtraHeaderHeight())
  const topSpacing = 60 + (extraHeaderHeight || 0)
  if (!forwardRef) forwardRef = createRef()

  const renderAppBanner = () => {
    const { pathname } = window.location
    const shouldHide = HIDE_ON_PAGES.some((path) => pathname.includes(path))

    if (shouldHide) return null
    return <AppBanner />
  }
  return (
    <Frame
      {...props}
      ref={forwardRef}
      topSpacing={topSpacing}
      className="scrollarea"
      safeAreaBottom={isIOS() && '100px'}
    >
      {renderAppBanner()}
      <ContentWrapper {...props}>{props.children}</ContentWrapper>
    </Frame>
  )
}
